export const extractTargetId = (href: string): string | null => {
	if (href.startsWith('/#') || href.startsWith('#')) {
		return href.startsWith('/#') ? href.substring(2) : href.substring(1);
	}
	return null;
};

export const scrollToElement = (targetId: string): void => {
	const targetElement = document.getElementById(targetId);

	if (targetElement) {
		targetElement.scrollIntoView({
			behavior: 'smooth',
			block: 'start',
		});
		window.history.pushState(null, '', `/#${targetId}`);
	}
};

export const handleAnchorClick = (event: Event, href: string): void => {
	const targetId = extractTargetId(href);

	if (!targetId) return;

	event.preventDefault();

	const targetElement = document.getElementById(targetId);
	if (targetElement) {
		setTimeout(() => scrollToElement(targetId), 100);
	} else {
		window.location.href = `/#${targetId}`;
	}
};

export const handleInitialAnchor = (): void => {
	const hash = window.location.hash;
	if (hash) {
		const targetId = hash.substring(1);
		setTimeout(() => {
			const targetElement = document.getElementById(targetId);
			if (targetElement) {
				targetElement.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
				});
			}
		}, 500);
	}
};
